export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_q03_b.c9fa14e1.png";